import { useState, useEffect, useCallback } from 'react';
import { apiFetch } from '../lib/api';
function mapProject(p) {
    const tc = p.taskCounts;
    const total = tc.pending + tc.assigned + tc.running + tc.completed + tc.failed + tc.blocked + tc.cancelled;
    return {
        id: p.id,
        name: p.name,
        status: p.status,
        budgetCents: p.budgetCents,
        spentCents: p.spentCents,
        createdAt: p.createdAt,
        updatedAt: p.updatedAt,
        completedAt: p.completedAt,
        tasks: { pending: tc.pending, running: tc.running, completed: tc.completed, failed: tc.failed, blocked: tc.blocked, total },
        workers: { active: p.activeWorkers },
    };
}
export function useProjects() {
    const [projects, setProjects] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchProjects = useCallback(async () => {
        try {
            const data = await apiFetch('/api/orchestrator/projects');
            setProjects((data.projects || []).map(mapProject));
            setError(null);
        }
        catch (e) {
            setError(e instanceof Error ? e.message : 'Failed to load projects');
        }
        finally {
            setIsLoading(false);
        }
    }, []);
    useEffect(() => {
        fetchProjects();
        const interval = setInterval(fetchProjects, 30000);
        return () => clearInterval(interval);
    }, [fetchProjects]);
    const createProject = useCallback(async (name, prdContent, githubRepo) => {
        const payload = { name, prdContent, visibilityMode: 'live', budgetCents: 5000 };
        if (githubRepo)
            payload.githubRepo = githubRepo;
        const data = await apiFetch('/api/orchestrator/projects', {
            method: 'POST',
            body: JSON.stringify(payload),
        });
        await fetchProjects();
        return data.projectId;
    }, [fetchProjects]);
    return { projects, isLoading, error, refresh: fetchProjects, createProject };
}
